<script>
	import firebase_ from 'firebase/app';
	import 'firebase/auth';
	
	export default {
		name: 'OtpExecuter',
		methods: {
			sendOtp(phone) {
				const self_ = this;

				if(window.recaptchaVerifier) {
					window.recaptchaVerifier.render().then(widgetId =>{
						window.recaptchaVerifier.reset(widgetId)
					})
				} else {
					window.recaptchaVerifier = new firebase_.auth.RecaptchaVerifier('recaptcha', {
						'size': 'invisible'
					})
				}

				// reCAPTCHA solved, allow signInWithPhoneNumber.
				let appVerifier_ = window.recaptchaVerifier;

				return new Promise((resolve,reject) => {
					Promise.resolve().then(() => {
						return self_.firebase.auth().signInWithPhoneNumber(phone, appVerifier_)
					}).then(result => {
						window.confirmationResult = result;
						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: signUpByPhone(' + phone + ') -> firebase.auth.signInWithPhoneNumber';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			verifyOtp(otp) {
				return window.confirmationResult.confirm(otp)
			}
		}
	}
</script>